import Swal from "sweetalert2";

export const swalNotice500 = () => {
  Swal.fire({
    icon: "error",
    title: "Thao tác thất bại",
    confirmButtonText: "Xác nhận",
    text: "Có lỗi trong quá trình tải dữ liệu, vui lòng kiểm tra và thử lại!",
  });
};

export const swalErrorText = (text) => {
  Swal.fire({
    icon: "error",
    title: "Thao tác thất bại",
    confirmButtonText: "Xác nhận",
    text: text,
  });
};

export const swalSuccess = () => {
  Swal.fire({
    icon: "success",
    title: "Thành công",
    confirmButtonText: "Xác nhận",
  });
};

export const toastNotice200 = () => {
  Toast.fire({
    icon: "success",
    title: "Thành công",
  });
};

export const toastNoticeLocked = () => {
  Toast.fire({
    icon: "error",
    title: "Đã có nhân viên xử lý",
  });
};

export const toastNoticeText = (icon, text) => {
  Toast.fire({
    icon: icon,
    title: text,
  });
};

export const swalValidationMess = (text) => {
  return Swal.showValidationMessage(text);
};

export const swalLoading = () => {
  return Swal.fire({
    allowOutsideClick: false,
    background: "none",
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 1500,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});
